import BaseOptionsModel from "../base_options_model";
import _ from '../../../../utils/underscore';

class AboutComponentModel extends BaseOptionsModel {

    init(params) {
        // TODO translate
        this
            ._setTaxID(params.taxID)
            ._setCID(params.cid)
            ._setClientVersion(params.clientVersion);
    }


    /**
     * set taxID. User must be logged in
     * @param taxID
     * @returns {AboutComponentModel}
     * @private
     */
    _setTaxID(taxID) {
        if (!_.isString(taxID)) {
            this.taxID = '';
        }
        this.taxID = taxID;

        return this;
    }

    /**
     * set CID. User must be logged in
     * @param cid
     * @returns {AboutComponentModel}
     * @private
     */
    _setCID(cid) {
        if (!_.isString(cid)) {
            this.cid = '';
        }
        this.cid = cid;

        return this;
    }


    /**
     * set client version
     * @param version
     * @returns {AboutComponentModel}
     * @private
     */
    _setClientVersion(version) {
        if (!_.isString(version)) {
            this.clientVersion = '';
        }
        this.clientVersion = version;

        return this;
    }

    /**
     * Implement getOptions base method
     * @returns {{cid: (string|*), clientVersion: (string|*)}}
     */
    getOptions() {
        return {cid: this.cid, clientVersion: this.clientVersion, taxID: this.taxID};
    }

}

export default AboutComponentModel;

